(function () {
  'use strict';

  /* Where a destination lives. The section renders this so the URL scheme is
     never hard-coded in the script. */
  var HOST = document.querySelector('[data-tg-maps]');
  var BASE = (HOST && HOST.getAttribute('data-dest-base')) || '/pages/travel-guide-';
  function destUrl(slug) { return BASE + slug; }

  /* ── geometry ───────────────────────────────────────────────────────────
     Every destination name, cash figure and link is already server-rendered in
     the cards and tables above. This only paints the picture, so a failed fetch
     costs the map and nothing else. */
  var RAMP = ['#bcd9a6', '#8ec489', '#57a76d', '#218455', '#0b4025'];

  function band(tier) {
    var share = (100 - tier) / 100, cuts = [0.18, 0.34, 0.50, 0.66];
    for (var i = 0; i < cuts.length; i++) { if (share < cuts[i]) return RAMP[i]; }
    return RAMP[4];
  }
  function el(tag, attrs, kids) {
    var n = document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (var k in attrs) { if (attrs[k] != null) n.setAttribute(k, attrs[k]); }
    (kids || []).forEach(function (c) { n.appendChild(c); });
    return n;
  }
  function txt(tag, attrs, s) { var n = el(tag, attrs); n.textContent = s; return n; }

  function drawAtlas(box, atlas) {
    Object.keys(atlas.panels).forEach(function (key) {
      var p = atlas.panels[key];
      var fig = document.createElement('figure');
      fig.className = 'at-panel at-panel--' + key;
      var svg = el('svg', { viewBox: p.viewBox, 'data-base': p.viewBox, role: 'img',
                            'aria-label': p.label + ' destinations covered by Matrix Forex' });
      p.context.forEach(function (d) { svg.appendChild(el('path', { 'class': 'at-ctx', d: d })); });
      var sch = el('g', { 'class': 'at-schengen', 'aria-hidden': 'true' });
      (p.schengen || []).forEach(function (d) { sch.appendChild(el('path', { 'class': 'at-sch', d: d })); });
      svg.appendChild(sch);
      Object.keys(p.countries).forEach(function (name) {
        var c = p.countries[name], slug = null;
        for (var s in atlas.dest) { if (atlas.dest[s].country === name) slug = s; }
        if (!slug) return;
        svg.appendChild(el('path', { 'class': 'at-cy', 'data-dest': slug, d: c.d,
                                     fill: band(atlas.dest[slug].tier), tabindex: '0',
                                     role: 'link', 'aria-label': name + ' travel guide' }));
        var card = document.querySelector('.at-card[data-dest="' + slug + '"] dd');
        if (!c.pinned && card) {
          svg.appendChild(txt('text', { 'class': 'at-cur', x: c.at[0], y: c.at[1],
                                        'text-anchor': 'middle' }, card.textContent));
        }
      });
      Object.keys(p.pins || {}).forEach(function (slug) {
        var xy = p.pins[slug], meta = atlas.dest[slug];
        if (!meta) return;
        var flip = xy[0] > parseFloat(p.viewBox.split(' ')[2]) * 0.6;
        var g = el('g', { 'class': 'at-pin', 'data-dest': slug });
        g.appendChild(el('circle', { cx: xy[0], cy: xy[1], r: 4 }));
        g.appendChild(txt('text', { x: flip ? xy[0] - 9 : xy[0] + 9, y: xy[1] + 4,
                                    'text-anchor': flip ? 'end' : 'start' }, meta.name));
        svg.appendChild(g);
      });
      fig.appendChild(svg);

      /* zoom controls: +, −, reset. The pan+zoom feature below wires them by
         looking for [data-zin]/[data-zout]/[data-reset] inside each .at-panel. */
      var zoom = document.createElement('div');
      zoom.className = 'at-zoom';
      var zin = document.createElement('button');
      zin.type = 'button'; zin.setAttribute('data-zin', ''); zin.setAttribute('aria-label', 'Zoom in');
      zin.textContent = '+';
      var zout = document.createElement('button');
      zout.type = 'button'; zout.setAttribute('data-zout', ''); zout.setAttribute('aria-label', 'Zoom out');
      zout.disabled = true; zout.innerHTML = '&minus;';
      var zreset = document.createElement('button');
      zreset.type = 'button'; zreset.setAttribute('data-reset', '');
      zreset.setAttribute('aria-label', 'Reset view'); zreset.title = 'Reset view';
      var ri = el('svg', { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
                           'stroke-width': '2.6', 'stroke-linecap': 'round',
                           'stroke-linejoin': 'round', 'aria-hidden': 'true' });
      ri.appendChild(el('path', { d: 'M3 12a9 9 0 1 0 3-6.7L3 8' }));
      ri.appendChild(el('path', { d: 'M3 3.5v5h5' }));
      zreset.appendChild(ri);
      zoom.appendChild(zin); zoom.appendChild(zout); zoom.appendChild(zreset);
      fig.appendChild(zoom);

      var cap = document.createElement('figcaption');
      cap.textContent = p.label;
      fig.appendChild(cap);
      box.appendChild(fig);
    });
  }

  function drawCountry(box, cm) {
    /* no outline for this destination (Schengen is a zone, not a country) —
       drop the empty container so it leaves no gap in the layout */
    if (!cm) { if (box.parentNode) box.parentNode.removeChild(box); return; }
    var svg = el('svg', { 'class': 'cm', viewBox: cm.viewBox, role: 'img',
                          'aria-label': 'Map of ' + cm.country });
    svg.appendChild(el('path', { 'class': 'cm-land', d: cm.d }));
    /* sub-regions drawn over the land fill in their own shade — see the
       tibet entry on china. Painted before the pins so labels stay on top. */
    (cm.shades || []).forEach(function (sh) {
      var p = el('path', { 'class': 'cm-shade', 'data-shade': sh.key, d: sh.d });
      if (sh.label) { p.appendChild(txt('title', {}, sh.label)); }
      svg.appendChild(p);
    });
    cm.pins.forEach(function (pin, i) {
      /* data-city carries the city block's key so the pin and its card can
         light each other; older entries without one fall back to the index */
      var g = el('g', { 'class': 'cm-pin', 'data-city': pin.key || i, tabindex: '0',
                        role: 'button', 'aria-label': pin.n });
      g.appendChild(el('circle', { cx: pin.x, cy: pin.y, r: 5 }));
      g.appendChild(txt('text', { x: pin.flip ? pin.x - 11 : pin.x + 11, y: pin.y + 4,
                                  'text-anchor': pin.flip ? 'end' : 'start' }, pin.n));
      svg.appendChild(g);
    });
    box.appendChild(svg);
  }

  function drawRegion(box, rg) {
    /* A region map is a set of sub-divisions (Tohoku's six prefectures) rather
       than one outline with city pins, so it gets its own drawing pass. */
    if (!rg) { if (box.parentNode) box.parentNode.removeChild(box); return; }
    var svg = el('svg', { 'class': 'pfsvg', viewBox: rg.viewBox, role: 'img',
                          'aria-label': 'Map of ' + (rg.label || 'the region') });
    Object.keys(rg.prefectures).forEach(function (key) {
      var p = rg.prefectures[key];
      var path = el('path', { 'class': 'pf', 'data-pf': key, d: p.d });
      path.appendChild(txt('title', {}, p.label));
      svg.appendChild(path);
      if (p.labelAt) {
        svg.appendChild(txt('text', { 'class': 'pflbl', 'data-pf': key, x: p.labelAt[0],
                                      y: p.labelAt[1], 'text-anchor': 'middle' }, p.label));
      }
    });
    box.appendChild(svg);
  }

  function drawJapan(box, jp) {
    if (!jp) { if (box.parentNode) box.parentNode.removeChild(box); return; }
    var svg = el('svg', { 'class': 'jp', id: 'jpmap', viewBox: jp.viewBox, role: 'img',
                          'aria-label': 'Map of the nine regions of Japan' });
    if (jp.insetBox) {
      /* the Okinawa inset frame — Okinawa is 1,000 km off the main islands, so
         the map borrows a corner for it rather than zooming everything out */
      var b = jp.insetBox;
      svg.appendChild(el('rect', { 'class': 'inset', x: b.x, y: b.y,
                                   width: b.w, height: b.h, rx: 3 }));
    }
    Object.keys(jp.regions).forEach(function (key) {
      var r = jp.regions[key];
      var path = el('path', { 'class': 'rg' + (r.href ? ' is-live' : ''), 'data-rg': key,
                              'data-href': r.href || '', d: r.d,
                              tabindex: '0', role: 'button' });
      path.appendChild(txt('title', {}, r.label));
      svg.appendChild(path);
      if (r.labelAt) {
        svg.appendChild(txt('text', { 'class': 'lbl', 'data-rg': key, x: r.labelAt[0],
                                      y: r.labelAt[1], 'text-anchor': 'middle' }, r.label));
      }
    });
    /* Text sits on the same coordinates as the dot; .pin--left/right/bottom do
       the offsetting in CSS, which is how the prototype renders them. */
    (jp.cities || []).forEach(function (c) {
      var g = el('g', { 'class': 'pin pin--' + (c.anchor || 'right'), 'data-city': c.key });
      g.appendChild(el('circle', { cx: c.x, cy: c.y, r: 3.2 }));
      g.appendChild(txt('text', { x: c.x, y: c.y }, c.name));
      svg.appendChild(g);
    });
    box.appendChild(svg);

    /* Region-card art: a card with no photo shows the region's own outline, so
       the card is never wrong about which region it is. The path lives in the
       map JSON; inject it into any .rc__art that the section left photo-less. */
    Object.keys(jp.regions).forEach(function (key) {
      var r = jp.regions[key];
      if (!r.silhouette) return;
      var art = document.querySelector('.rc[data-rgn="' + key + '"] .rc__art');
      if (!art || art.querySelector('img') || art.querySelector('.rc__shape')) return;
      var sil = el('svg', { 'class': 'rc__shape', viewBox: '0 0 100 100', 'aria-hidden': 'true' });
      sil.appendChild(el('path', { d: r.silhouette }));
      art.insertBefore(sil, art.firstChild);
    });
  }

  function features() {


  /* ── hub: search + region filter ─────────────────────────────────────── */
  var grid = document.getElementById('tg-grid');
  if (grid) {
    var cards = [].slice.call(grid.querySelectorAll('.pc'));
    var q = document.getElementById('tg-q');
    var empty = document.getElementById('tg-empty');
    var btns = [].slice.call(document.querySelectorAll('.fbtn'));
    var region = 'all';

    function apply() {
      var term = ((q && q.value) || '').trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (c) {
        var okR = region === 'all' || c.dataset.region === region;
        var okQ = !term || (c.dataset.search || '').indexOf(term) !== -1;
        var show = okR && okQ;
        c.style.display = show ? '' : 'none';
        if (show) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        region = b.dataset.r;
        btns.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
        apply();
      });
    });
    if (q) q.addEventListener('input', apply);
  }

  /* ── atlas: continent panels ─────────────────────────────────────────── */
  (function () {
    var atlas = document.getElementById('tg-atlas-sec');
    if (!atlas) return;

    var targets = [].slice.call(atlas.querySelectorAll('[data-dest]'));
    var cards = [].slice.call(atlas.querySelectorAll('.at-card'));
    var hint = atlas.querySelector('.at-detail__hint');
    var cardsByDest = {};
    cards.forEach(function (c) { cardsByDest[c.dataset.dest] = c; });

    // the postcards above and the map are two views of one set — light the match
    var postcards = {};
    [].slice.call(document.querySelectorAll('.pc')).forEach(function (pc) {
      var slug = pc.getAttribute('data-dest');
      if (slug) postcards[slug] = pc;
    });
    var allPc = Object.keys(postcards).map(function (k) { return postcards[k]; });

    function show(dest) {
      cards.forEach(function (c) { c.hidden = c.dataset.dest !== dest; });
      if (hint) hint.hidden = !!dest;
      targets.forEach(function (t) { t.classList.toggle('is-on', t.dataset.dest === dest); });
      allPc.forEach(function (pc) {
        pc.classList.toggle('is-lit', dest && postcards[dest] === pc);
        pc.classList.toggle('is-dim', !!dest && postcards[dest] !== pc);
      });
    }
    function clear() { show(null); }

    targets.forEach(function (t) {
      var dest = t.dataset.dest;
      t.addEventListener('mouseenter', function () { show(dest); });
      t.addEventListener('focus', function () { show(dest); });
      t.addEventListener('click', function () { window.location.href = destUrl(dest); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); window.location.href = destUrl(dest); }
      });
    });
    atlas.querySelector('.atlas__maps').addEventListener('mouseleave', clear);

    /* pan + zoom, clamped to the panel bounds — viewBox maths, no library */
    [].slice.call(atlas.querySelectorAll('.at-panel')).forEach(function (fig) {
      var svg = fig.querySelector('svg[data-base]');
      if (!svg) return;                       // no map in this panel, nothing to pan
      var base = svg.getAttribute('data-base').split(' ').map(Number);   // [0,0,W,H]
      var BW = base[2], BH = base[3];
      var vb = { x: 0, y: 0, w: BW, h: BH };
      var zin = fig.querySelector('[data-zin]'),
          zout = fig.querySelector('[data-zout]'),
          reset = fig.querySelector('[data-reset]');

      function commit() {
        // never zoom out past the base frame, never pan outside it
        vb.w = Math.min(vb.w, BW); vb.h = Math.min(vb.h, BH);
        vb.x = Math.max(0, Math.min(vb.x, BW - vb.w));
        vb.y = Math.max(0, Math.min(vb.y, BH - vb.h));
        svg.setAttribute('viewBox', vb.x + ' ' + vb.y + ' ' + vb.w + ' ' + vb.h);
        if (zout) zout.disabled = vb.w >= BW - 0.5;
        if (zin) zin.disabled = vb.w <= BW * 0.22;
      }
      function zoom(f) {
        var nw = Math.max(BW * 0.2, Math.min(BW, vb.w * f));
        var nh = nw * (BH / BW);
        vb.x += (vb.w - nw) / 2; vb.y += (vb.h - nh) / 2;   // hold the centre
        vb.w = nw; vb.h = nh; commit();
      }
      if (zin) zin.addEventListener('click', function () { zoom(0.7); });
      if (zout) zout.addEventListener('click', function () { zoom(1 / 0.7); });
      if (reset) reset.addEventListener('click', function () {
        vb = { x: 0, y: 0, w: BW, h: BH }; commit();
      });

      var drag = null;
      function down(e) {
        var pt = e.touches ? e.touches[0] : e;
        drag = { px: pt.clientX, py: pt.clientY, ox: vb.x, oy: vb.y,
                 scale: vb.w / svg.getBoundingClientRect().width };
        svg.classList.add('is-dragging');
      }
      function move(e) {
        if (!drag) return;
        var pt = e.touches ? e.touches[0] : e;
        vb.x = drag.ox - (pt.clientX - drag.px) * drag.scale;
        vb.y = drag.oy - (pt.clientY - drag.py) * drag.scale;
        commit();
        if (e.cancelable) e.preventDefault();
      }
      function up() { drag = null; svg.classList.remove('is-dragging'); }

      svg.addEventListener('mousedown', down);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', up);
      svg.addEventListener('touchstart', down, { passive: true });
      svg.addEventListener('touchmove', move, { passive: false });
      svg.addEventListener('touchend', up);
      commit();
    });

    // Schengen is a zone, not a country — it only renders when asked for
    var btn = atlas.querySelector('[data-schengen]');
    if (btn) {
      btn.addEventListener('click', function () {
        var on = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        [].slice.call(atlas.querySelectorAll('.at-schengen')).forEach(function (g) {
          g.classList.toggle('is-on', on);
        });
      });
    }
  })();

  /* ── country map: pins <-> city cards ────────────────────────────────── */
  (function () {
    var pins = [].slice.call(document.querySelectorAll('.cm-pin'));
    /* .city is the "Where to go" grid the section renders; .cm-card is the
       older side list. Both key off data-city, so either can drive the map. */
    var cards = [].slice.call(document.querySelectorAll('.cm-card, .city[data-city]'));
    if (!pins.length) return;
    function lit(i) {
      pins.forEach(function (p) { p.classList.toggle('is-on', p.dataset.city === i); });
      cards.forEach(function (c) { c.classList.toggle('is-on', c.dataset.city === i); });
    }
    function clear() { lit(null); }
    pins.concat(cards).forEach(function (el) {
      el.addEventListener('mouseenter', function () { lit(el.dataset.city); });
      el.addEventListener('focus', function () { lit(el.dataset.city); });
      el.addEventListener('mouseleave', clear);
      el.addEventListener('blur', clear);
    });
  })();

  /* ── FAQ accordion ───────────────────────────────────────────────────── */
  [].slice.call(document.querySelectorAll('.faq__q')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.parentElement;
      var panel = row.querySelector('.faq__a');
      var open = row.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '';
    });
  });

  /* ── region map (scoped: it early-returns, and anything appended after
     it in the main scope would otherwise never run) ──────────────────── */
  (function () {
  var map = document.getElementById('jpmap');
  if (!map) return;

  var panels = [].slice.call(document.querySelectorAll('.rc'));
  var shapes = [].slice.call(map.querySelectorAll('.rg'));
  var labels = [].slice.call(map.querySelectorAll('.lbl'));
  var chips = [].slice.call(document.querySelectorAll('.rchip'));

  function select(key) {
    panels.forEach(function (p) { p.hidden = p.dataset.rgn !== key; });
    shapes.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-rg') === key); });
    labels.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('data-rg') === key); });
    chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.rg === key ? 'true' : 'false'); });
  }

  // the chips are the keyboard and screen-reader interface; the map is the
  // pointer interface. Both drive the same select().
  chips.forEach(function (c) {
    c.addEventListener('click', function () { select(c.dataset.rg); });
    c.addEventListener('focus', function () { select(c.dataset.rg); });
  });
  shapes.forEach(function (p) {
    var key = p.getAttribute('data-rg');
    var href = p.getAttribute('data-href');
    p.addEventListener('mouseenter', function () { select(key); });
    p.addEventListener('click', function () {
      select(key);
      // only regions whose guide is published navigate; the rest just show the card
      if (href) { window.location.href = href; return; }
      var chip = chips.filter(function (c) { return c.dataset.rg === key; })[0];
      if (chip) chip.focus();
    });
  });

  // city cards sit above the map; hovering one lights its pin below, so the two
  // hierarchies read as one system at two zoom levels rather than rival menus
  var pins = [].slice.call(map.querySelectorAll('.pin'));
  [].slice.call(document.querySelectorAll('.city')).forEach(function (card) {
    var city = card.getAttribute('data-city');
    var region = card.getAttribute('data-region');
    card.addEventListener('mouseenter', function () {
      pins.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-city') === city); });
      if (region) select(region);
    });
    card.addEventListener('mouseleave', function () {
      pins.forEach(function (p) { p.classList.remove('is-on'); });
    });
  });

  // deep-link support: japan.html#region-tohoku opens on that region, so a
  // region can be linked and shared directly
  function fromHash() {
    var m = /^#region-([a-z-]+)$/.exec(window.location.hash || '');
    return m && document.getElementById('rgn-' + m[1]) ? m[1] : null;
  }
  // default to Kanto — the region most Indian itineraries actually begin in
  select(fromHash() || 'kanto');
  window.addEventListener('hashchange', function () {
    var k = fromHash();
    if (k) select(k);
  });
  })();
  }

  /* ── boot ───────────────────────────────────────────────────────────────
     Paint the geometry, then wire everything up. `features()` runs whether or
     not the fetch succeeded: search, the region filter, the FAQ accordion and
     the region panels are all server-rendered and must survive a dead map. */
  function paint(data) {
    var atlasBox = document.getElementById('tg-atlas');
    var cmapBox = document.getElementById('tg-cmap');
    var jpBox = document.getElementById('tg-jpmap');
    var pfBox = document.getElementById('tg-pfmap');
    var slug = HOST ? HOST.getAttribute('data-country') : null;
    var rgKey = HOST ? HOST.getAttribute('data-region-map') : null;
    if (atlasBox && data && data.atlas) { drawAtlas(atlasBox, data.atlas); }
    if (cmapBox) { drawCountry(cmapBox, data && data.countries && data.countries[slug]); }
    if (jpBox) { drawJapan(jpBox, data && data.japan); }
    if (pfBox) { drawRegion(pfBox, data && data.regions && data.regions[rgKey]); }
  }

  var url = HOST && HOST.getAttribute('data-tg-maps');
  if (!url || !window.fetch) { paint(null); features(); return; }
  fetch(url)
    .then(function (r) { return r.json(); })
    .then(function (data) { paint(data); })
    .catch(function () { paint(null); })
    .then(features, features);
})();
